import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconDirectionsCar = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconDirectionsCar",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M240-200v20q0 25-17 43t-43 17-42-17-18-43v-286l1-14 3-13 75-213q8-24 29-39t47-15h410q26 0 47 15t29 39l75 213 3 13 1 14v286q0 25-17 43t-43 17-42-17-18-43v-20zm-8-360h496l-42-120H274zm68 240q25 0 43-17t17-43-17-42-43-18-42 18-18 42 18 43 42 17m360 0q25 0 43-17t17-43-17-42-43-18-42 18-18 42 18 43 42 17"
  })
}));